/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BankMessagesViewModel } from "../types/BankMessagesViewModel.ts";

export const bankMessagesViewModelSchema = z.object({
  instruction1: z.string().nullish(),
  instruction2: z.string().nullish(),
  instruction3: z.string().nullish(),
  allowPecegePay: z.optional(z.boolean()),
}) as unknown as ToZod<BankMessagesViewModel>;
